import styled from '@emotion/styled';

export const TileWrapper = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    border-radius: 0.4rem;
    width: 100%;
    &:first-of-type {
        margin-bottom: 2rem;
        margin-right: 0;
    }
    @media screen and (min-width: 1024px) {
        &:first-of-type {
            margin-right: 2rem;
            margin-bottom: 0;
        }
    }
    .top {
        display: flex;
        flex-grow: 1;
        justify-content: space-between;
        flex-wrap: wrap-reverse;
        border-bottom: 2px solid #e8eaec;
        img {
            align-self: baseline;
            margin-left: 2rem;
            height: 13.6rem;
        }
        @media screen and (min-width: 768px) {
            flex-wrap: nowrap;
            min-height: 18.4rem;
            img {
                margin-right: 4rem;
                height: 17rem;
            }
        }
    }

    .bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 4.6rem;
        padding: 0 1.2rem;
        color: #8241aa;
        @media screen and (min-width: 768px) {
            height: 6rem;
            padding: 0 2rem;
        }
        svg {
            margin-right: 1.2rem;
            transition-property: transform;
            transition-duration: 0.2s;
            fill: #8241aa;
            @media screen and (min-width: 768px) {
                margin-right: 3rem;
            }
        }
        &:hover {
            svg {
                @media screen and (min-width: 768px) {
                    transform: translateX(2rem);
                }
            }
        }
    }
`;

export const TextWrapper = styled.section`
    padding: 1.2rem 1.2rem 2rem;
    width: 100%;
    h2 {
        margin-bottom: 0.8rem;
    }
    p {
        font-size: 1.4rem;
        margin-bottom: 0;
    }

    @media screen and (min-width: 768px) {
        margin-right: 8rem;
        padding: 2rem;
        p {
            margin-bottom: 2.4rem;
        }
    }
`;
